import { NSARouterMakerResult } from "namirasoft-account-react";
import { PartyTypeInputRow, PartyTypeRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class PartyTypeEditPage extends Component<Props>
{
    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        return (
            <ErpLayout<PartyTypeRow, PartyTypeInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.party_type(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): PartyTypeInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        party_type_category: [],
                                        party_type_tag: [],
                                        party_type_field: [],
                                    }),
                                    setRow: (row: PartyTypeRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}